import { getStyles } from './helpers/getStyles'

let nativeGridStyles: any = {
  background: 'white'
}

let imageStyles: object = {
  'min-height': '100px',
  width: '100%',
  'grid-column-start': 1,
  'grid-column-end': 'span',
  'grid-row-start': 1,
  'grid-row-end': 5,
  'align-items': 'center',
  'align-self': 'center',
  'justify-content': 'center',
  overflow: 'hidden',
  position: 'relative',
  'background-repeat': 'no-repeat',
  'background-position': 'center center',
  'background-size': 'cover',
  'border-top': '8px solid #bebebe',
  'border-bottom': '8px solid #bebebe'
}

const imageAnchorStyles = {
  height: '100%',
  width: '100%',
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0
}

const titleStyles = {
  'line-height': 'initial',
  'letter-spacing': 'initial',
  color: '#333',
  'font-weight': 'bold',
  'font-size': '20px',
  'grid-row-start': 2,
  'grid-column-start': 2,
  'align-items': 'center',
  overflow: 'hidden',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
  'text-align': 'center'
}

const sponsorStyles = {
  'grid-row-start': 1,
  'grid-column-start': 2,
  padding: '8px 8px 8px 24px',
  'text-transform': 'emphasis',
  'font-size': '13px',
  color: '#555'
}

const ctaStyles = {
  'grid-row-start': 4,
  'grid-column-start': 2,
  'align-self': 'center',
  'text-align': 'left',
  padding: '8px 16px 8px 24px'
}

const ctaAnchorStyles = {
  display: 'block',
  'text-decoration': 'none',
  'background-color': '#eee',
  padding: '8px 48px',
  color: '#333',
  'font-weight': 'bold',
  'text-align': 'center',
  'font-size': '15px',
  'text-transform': 'uppercase'
}

const bodyStyles = {
  'align-self': 'center',
  'grid-row-start': 3,
  'grid-column-start': 2,
  'line-height': 'initial',
  'letter-spacing': 'initial',
  'font-size': '15px',
  overflow: 'hidden',
  '-webkit-line-clamp': 3,
  '-webkit-box-orient': 'vertical',
  'text-align': 'center'
}

const mobileMaxWidth = 768

if (window.outerWidth > mobileMaxWidth) {
  bodyStyles['padding'] = '10px 10px 10px 24px'
  titleStyles['padding'] = '10px 10px 10px 24px'

  nativeGridStyles = {
    display: 'grid',
    'grid-template-columns': '40% auto',
    'grid-template-rows': '10% auto',
    padding: '2% 0',
    'border-top': '1px solid #eee',
    'border-bottom': '1px solid #eee',
    background: 'white'
  }

  ctaAnchorStyles['display'] = 'inline-block'

  /** Make sizes fit with ad box */
  imageStyles = {
    ...imageStyles,
    'min-height': '250px',
    width: '100%',
    'grid-column-start': 1,
    'grid-column-end': 'span',
    'grid-row-start': 1,
    'grid-row-end': 5,
    'align-items': 'center',
    'align-self': 'center',
    'justify-content': 'center',
    overflow: 'hidden',
    position: 'relative',
    'background-repeat': 'no-repeat',
    'background-position': 'center center',
    'background-size': 'cover',
    'border-top': '8px solid #bebebe',
    'border-bottom': '8px solid #bebebe'
  }
}
const videoStyles = {
  'grid-column-start': 1,
  'grid-column-end': 'span',
  'grid-row-start': 1,
  'grid-row-end': 5
}

export const template = `
<div style="${getStyles(nativeGridStyles)}">

  <div style="${getStyles(
    videoStyles
  )}" data-native-size="[300, 250]" data-native-type="video">
  </div>

  <div style="${getStyles(
    imageStyles
  )}" data-native-min-size="[100, 100]" data-native-type="image">
  </div>
  <div style="${getStyles(sponsorStyles)}" data-native-type="sponsoredBy"></div>
  <h3 style="${getStyles(
    titleStyles
  )}" data-native-type="title" data-native-len="80" data-native-d-len="120"></h3>
  <p style="${getStyles(
    bodyStyles
  )}"  data-native-type="body" data-native-len="80" data-native-d-len="340"></p>
  <div style="${getStyles(ctaStyles)}" data-native-type="clickUrl">
      <span style="${getStyles(ctaAnchorStyles)}" data-native-type="cta"></span>
    </a>
  </div>
</div>
`
